import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AngularFaviconService } from 'angular-favicon';
import { MessageService } from 'primeng/api';
import { appConfig } from 'src/app/app.config';
import { HomeService } from 'src/app/services/home/home.service';
import { LoginService } from 'src/app/services/login/login.service';
import { MediaService } from 'src/app/services/media.service';
import { environment } from 'src/environments/environment';
// import { forkJoin, of, Observable } from 'rxjs';
// import { catchError, map, take } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { DialogModule } from 'primeng/dialog';
import { CarouselModule } from 'primeng/carousel';
import { HeaderUploadProgressComponent } from './header-upload-progress/header-upload-progress.component';
// import { PaginatorModule } from 'primeng/paginator';
@Component({
  standalone: true,
  imports: [
    NgbCarouselModule,
    CommonModule,
    DialogModule,
    CarouselModule,
    FormsModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    HeaderUploadProgressComponent,
  ],
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  userDetail: any;
  userName: any;
  homeLogo = 'assets/images/logo.png';
  headerLinkColor: any;
  logoSize: any;
  theme: any;
  headerLogo: any;
  favIcon: any;
  web: any;
  showMenu = false;
  mainPageName: any;
  vodPageName: any;
  contactName: any;
  appBGColor: any;
  appStoreName: any;
  channelName: any;
  networkName: any;
  givingPageName: any;
  appBtnPrimaryColor: any;
  mainBGBlur: any;
  footerBlur: any;
  blurOpacity: any;
  scrHeight: any;
  signoutModal = false;
  scrWidth: any;
  removeheaderData = false;
  /** User has ROLE_MEDIA_EDITOR (any combination). */
  isMediaEditor = false;
  /** User has only ROLE_MEDIA_EDITOR — restricted header (no VOD/ebook/channel nav; Dashboard still shown). */
  isOnlyMediaEditor = false;
  manageMediaOpen = false;
  manageMediaOptions: Array<{ name: string; route?: string }> = [];

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const node = event.target as Node;
    const host = node instanceof Element ? node : node.parentElement;
    if (host?.closest('.manage-media-wrapper') || host?.closest('.mobile-manage-media-wrapper')) {
      return;
    }
    this.manageMediaOpen = false;
  }

  @HostListener('window:resize', ['$event'])
  updateHeaderState() {
    if (this.router.url.includes('giving') && this.scrWidth < 500) {
      this.removeheaderData = true;
    } else {
      this.removeheaderData = false;
    }
  }
  getScreenSize() {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
    this.updateHeaderState();
  }
  showHideEbook: boolean;
  showHideGiving: boolean;
  ebookPage: string;
  isEbookUrl: boolean;
  isVideoUrl: boolean;
  isAppStore: boolean;
  isChannelPage: boolean;
  isNetworkPage: boolean;
  networkPageType: string;
  appStorePage: string;
  isHomePage: boolean;
  isVodPage: boolean;
  organizationUuid: string;
  isLivePage: boolean;
  livePageContent: string;
  constructor(
    public router: Router,
    public messageService: MessageService,
    public loginService: LoginService,
    public homeService: HomeService,
    private elementRef: ElementRef,
    private ngxFavicon: AngularFaviconService,
    private sanitizer: DomSanitizer,
    private _MediaService: MediaService,
  ) {
    this.router.events.subscribe(() => {
      this.updateHeaderState();
    });
    this.getScreenSize();
    this.showHideEbook = false;
    this.showHideGiving = false;
    this.ebookPage = '';
    this.isEbookUrl = false;
    this.isVideoUrl = false;
    this.isAppStore = false;
    this.isChannelPage = false;
    this.isNetworkPage = false;
    this.networkPageType = ""
    this.appStorePage = '';
    this.isHomePage = false;
    this.isVodPage = false;
    this.organizationUuid = '';
    this.isLivePage = false;
    this.livePageContent = '';
  }

  ngOnInit(): void {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
    this.updateHeaderState();
    this.loadHeaderContent();
  }

  loadHeaderContent(): void {
    this.userDetail = localStorage.getItem('loggedInUser');
    if (this.userDetail) {
      const parsed = JSON.parse(this.userDetail);
      const userDetails = parsed?.userDetails ?? parsed;

      this.userName = userDetails?.firstName ?? userDetails?.name ?? '';

      const rawRoles: any =
        userDetails?.roles ?? userDetails?.userRoles ?? userDetails?.authorities ?? [];
      const roles = this.extractRoleNames(rawRoles, parsed);
      this.isMediaEditor = roles.includes('ROLE_MEDIA_EDITOR');
      this.isOnlyMediaEditor =
        this.isMediaEditor && roles.length === 1 && roles[0] === 'ROLE_MEDIA_EDITOR';

      const featureList: Array<{ name: string; isView: boolean; key?: string }> =
        userDetails?.featureList ?? [];

      if (featureList && featureList.length > 0) {
        this.manageMediaOptions = featureList
          .filter((feature) => feature?.isView)
          // For now: do not show Channels in Manage Media dropdown
          .filter((feature) => (feature.name || '').toLowerCase() !== 'channels')
          .map((feature) => ({
            name: feature.name,
            route: this.resolveManageMediaRoute(feature.name),
          }))
          .filter((opt) => opt.route != null);
      } else if (this.isMediaEditor) {
        this.manageMediaOptions = [
          // { name: 'Channels', route: '/web-admin/channel' },
          { name: 'Videos', route: '/web-admin/video' },
          // { name: 'Bookstore', route: '/web-admin/bookstore' },
          { name: 'Folder', route: '/web-admin/folder' },
          // { name: 'Music', route: '/web-admin/music' },
        ];
      } else {
        this.manageMediaOptions = [];
      }
    } else {
      this.userName = '';
      this.isMediaEditor = false;
      this.isOnlyMediaEditor = false;
      this.manageMediaOptions = [];
    }
    // this.applyManageMediaAvailabilityFilters();÷
    this.web = `${window.location.protocol}//${window.location.hostname}/`;
    if (this.router.url.includes('ebook')) {
      this.isEbookUrl = true;
    }
    if (this.router.url.includes('video')) {
      this.isVideoUrl = true;
    }
    this.getSubscribe();
  }

  private extractRoleNames(rawRoles: any, parsedPayload: any): string[] {
    const names = new Set<string>();

    if (Array.isArray(rawRoles)) {
      rawRoles.forEach((role: any) => {
        if (typeof role === 'string') {
          names.add(role);
          return;
        }
        if (role && typeof role === 'object') {
          if (role.authority) {
            names.add(String(role.authority));
          }
          if (role.name) {
            names.add(String(role.name));
          }
          if (role.roleName) {
            names.add(String(role.roleName));
          }
        }
      });
    }

    // Fallback for inconsistent payload shapes seen across environments.
    if (names.size === 0 && typeof parsedPayload === 'object' && parsedPayload) {
      const serialized = JSON.stringify(parsedPayload);
      if (serialized.includes('ROLE_MEDIA_EDITOR')) {
        names.add('ROLE_MEDIA_EDITOR');
      }
    }

    return Array.from(names);
  }

  /**
   * Manage Media menu routes (featureList from API + media-editor fallback).
   */
  private resolveManageMediaRoute(featureName: string | undefined): string | undefined {
    const n = featureName?.toLowerCase() ?? '';
    // For now: Channels hidden from Manage Media dropdown
    // if (n === 'channels') {
    //   return '/web-admin/channel';
    // }
    if (n === 'videos') {
      return '/web-admin/video';
    }
    // if (n === 'bookstore') return '/web-admin/bookstore';
    if (n === 'folder' || n === 'folders') {
      return '/web-admin/folder';
    }
    // if (n === 'music') return '/web-admin/music';
    return undefined;
  }

  // /**
  //  * Hides Channels / Videos entries when the org has no items in that catalog (same APIs as admin lists).
  //  * If nothing remains, the Manage Media dropdown is hidden entirely.
  //  */
  // private applyManageMediaAvailabilityFilters(): void {
  //   if (!this.userName || this.manageMediaOptions.length === 0) {
  //     return;
  //   }
  //   const baseline = [...this.manageMediaOptions];
  //   const needChannels = baseline.some((o) => o.route === '/web-admin/channel');
  //   const needVideos = baseline.some((o) => o.route === '/web-admin/video');
  //   const requests: Observable<boolean>[] = [];
  //   if (needChannels) {
  //     requests.push(
  //       this.homeService.getAllMediaItemList('CHANNEL', 1, 1).pipe(
  //         map((r: any) => (r?.data?.totalElements ?? 0) > 0),
  //         catchError(() => of(true)),
  //       ),
  //     );
  //   }
  //   if (needVideos) {
  //     requests.push(
  //       this.homeService.getAllMediaItemList('MEDIA_ITEM', 1, 1).pipe(
  //         map((r: any) => (r?.data?.totalElements ?? 0) > 0),
  //         catchError(() => of(true)),
  //       ),
  //     );
  //   }
  //   if (requests.length === 0) {
  //     return;
  //   }
  //   forkJoin(requests)
  //     .pipe(take(1))
  //     .subscribe((results) => {
  //       let idx = 0;
  //       const hasChannels = needChannels ? results[idx++] : false;
  //       const hasVideos = needVideos ? results[idx++] : false;
  //       this.manageMediaOptions = baseline.filter((opt) => {
  //         if (opt.route === '/web-admin/channel') {
  //           return hasChannels;
  //         }
  //         if (opt.route === '/web-admin/video') {
  //           return hasVideos;
  //         }
  //         return true;
  //       });
  //       this.manageMediaOpen = false;
  //     });
  // }

  logOut() {
    this.loginService.logOutUser().subscribe(
      (response: any) => {
        this._MediaService.setVideoPlayerStatus(false);
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Logged out successful.',
        });
        this.signoutModal = false;
        localStorage.clear();
        this.loadHeaderContent();
        console.log(window.location)
        if (window.location.pathname === "/main") {
          window.location.reload()
        }
        else {
          this.router.navigate(['/main']);
        }
      },
      (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.error.message,
        });
      },
    );
  }

  getSubscribe() {
    this.homeService.sendPageData$.subscribe((response: any) => {
      console.log(response, 'response');
      if (response.data) {
        this.mainPageName = response.data.pageCustomizationDTO.homePage;
        this.vodPageName = response.data.pageCustomizationDTO.watchDailyPage;
        this.contactName = response.data.pageCustomizationDTO.contactUs;
        this.showHideEbook = response.data.pageCustomizationDTO.showHideEbook;
        this.appStoreName = response.data.pageCustomizationDTO.appStorePage;
        this.channelName = response.data.pageCustomizationDTO.channelName;
        this.networkName = response.data.pageCustomizationDTO.networkName;
        this.givingPageName = response.data.pageCustomizationDTO.givingPage;
        this.showHideGiving = response.data.pageCustomizationDTO.showHideGiving;
        this.ebookPage = response.data.pageCustomizationDTO.ebookPage;
        this.isHomePage = response.data.pageCustomizationDTO.showHideHome;
        this.isVodPage = response.data.pageCustomizationDTO.showHideVOD;
        this.isAppStore = response.data.pageCustomizationDTO.showHideAppstore;
        this.isChannelPage = response.data.pageCustomizationDTO.showHideTvChannel;
        this.isNetworkPage = response.data.pageCustomizationDTO.showHideNetwork;
        this.networkPageType = response.data.pageCustomizationDTO.networkType;
        this.appStorePage = response.data.pageCustomizationDTO.appStorePage;
        this.organizationUuid = response.data.pageCustomizationDTO.uuid;
        this.isLivePage = response.data.pageCustomizationDTO.isIFrame;
        this.livePageContent = response.data.pageCustomizationDTO.liveStreamTabName.trim();
        // webappSetting -----------------
        this.appBGColor = response.data.pageCustomizationDTO.backgroundColor;
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = this.appBGColor;

        this.appBtnPrimaryColor = this.sanitizer.bypassSecurityTrustStyle(
          `${response.data.pageCustomizationDTO.primaryColor}`,
        );

        this.headerLinkColor = response.data.headerDTO.headerLinksColor;
        if (this.scrWidth < 500) {
          this.logoSize = response.data.headerDTO.mobileLogoSize;
        } else if (this.scrWidth > 500 && this.scrWidth < 900) {
          this.logoSize = response.data.headerDTO.tabletLogoSize;
        } else {
          this.logoSize = response.data.headerDTO.webLogoSize;
        }
        this.theme = response.data.pageCustomizationDTO.colorScheme
          ? (response.data.pageCustomizationDTO.colorScheme = 'light')
          : (response.data.pageCustomizationDTO.colorScheme = 'dark');
        this.headerLogo = response.data.headerDTO.logoId
          ? `${appConfig.imageURL}` + response.data.headerDTO.logoId
          : '';

        this.favIcon = response.data.pageCustomizationDTO.faviconId
          ? `${appConfig.imageURL}` + response.data.pageCustomizationDTO.faviconId
          : '';
        this.ngxFavicon.setFavicon(this.favIcon);
        // updateHeaderState() {
        //   if (this.router.url.includes('giving') && this.scrWidth < 500) {
        //     this.removeheaderData = true;
        //   } else {
        //     this.removeheaderData = false;
        //   }
        // }

      }
    });
  }

  openNav() {
    const sidebar = document.getElementById('mySidenav');
    if (this.scrWidth < 650) {
      sidebar ? (sidebar.style.width = '500px') : null;
    } else if (this.scrWidth > 650 && this.scrWidth < 900) {
      sidebar ? (sidebar.style.width = '700px') : null;
    }
    // document.getElementById("mySidenav").style.width = "250px";
  }

  closeNav() {
    const sidebar = document.getElementById('mySidenav');
    sidebar ? (sidebar.style.width = '0') : null;
    // setTimeout(() => {
    //   if (this.router.url.includes('giving') && this.scrWidth < 500) {
    //     this.removeheaderData = true;
    //   } else {
    //     this.removeheaderData = false;
    //   }
    // }, 300);
    // document.getElementById("mySidenav").style.width = "250px";
  }
  toggleManageMedia(event: Event): void {
    event.stopPropagation();
    this.manageMediaOpen = !this.manageMediaOpen;
  }

  onManageMediaOptionClick(option: { name: string; route?: string }, event: Event): void {
    event.stopPropagation();
    this.manageMediaOpen = false;
    if (option.route) {
      this.router.navigate([option.route]);
    }
  }

  isManageMediaOptionActive(option: { route?: string }): boolean {
    if (!option?.route) {
      return false;
    }
    return this.router.url.startsWith(option.route);
  }

  isManageMediaSectionActive(): boolean {
    return this.manageMediaOptions.some((option) => this.isManageMediaOptionActive(option));
  }

  navigateForFreeAccount(): void {
    window.open(`${environment.dashboard}signup/${this.organizationUuid}`, '_blank');
  }

  onImageLoad(event: Event) {
    const img = event.target as HTMLImageElement;
    const width = img.width;
    const height = img.height;

    this.homeService.setDimensions(width, height);
  }
}
